import { useEffect } from 'react';
import { lighten } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { CacheKeys } from 'utils/cacheKeys';
import { getCookie } from 'utils/helperFunctions';

interface BrandingControllerProps {
  title?: string;
  faviconUrl?: string;
  description?: string;
}

export const BrandingController = ({ title, faviconUrl, description }: BrandingControllerProps) => {
  const storedThemeColor = getCookie(CacheKeys.themeColor) || '#4B22A8';

  useEffect(() => {
    const selectionColor = lighten(storedThemeColor, 0.9);
    document.documentElement.style.setProperty('--selection-bg', selectionColor);
  }, [storedThemeColor]);

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {faviconUrl && (
        <link rel='icon' type='image/png' href={`${faviconUrl}?v=${Date.now()}`} crossOrigin='anonymous' />
      )}
      {description && <meta name='description' content={description} />}
    </Helmet>
  );
};
